import React, { Component } from 'react'
import { Col, Row, Table } from 'antd';
import DisplayAmount from '../common/DisplayAmount';

export default class InfoProducts extends Component {

    constructor(props) {
        super(props)

        const { t } = this.props;
        this.columns = [
            {
                title: t('Article code'),
                dataIndex: 'codigodearticulo',
                key: 'codigodearticulo',
            },
            {
                title: t('Name'),
                dataIndex: 'descripcion',
                key: 'descripcion',
            },
            {
                title: t('Quantity'),
                dataIndex: 'cantidad',
                key: 'cantidad',
            },
            {
                title: t('Price'),
                dataIndex: 'precioFinal',
                key: 'precioFinal',
                render: (text, record) => {
                    return (
                        <DisplayAmount amount={record.precioFinal} />
                    )
                }
            },
        ]
    }

    renderRows(record) {
        const { t } = this.props
        let discount = 0

        if (record.descuento) {
            record.descuento.forEach(desc => {
                let number = parseInt(desc)
                if (discount) {
                    discount += number.toFixed(2) + "% +"
                } else {
                    discount = number.toFixed(2) + "% +"
                }
            });
        }

        return (
            <Col span={22} offset={2}>
                <Row>
                    <Col>
                        <b>
                            {t('Discounts applied') + ': '}
                        </b>
                        {discount &&
                            <span>
                            {discount.slice(0, -1)}
                            </span>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <b>
                            {t('Remarks') + ': '}
                        </b>
                        <span>
                            {record.observaciones}
                        </span>
                    </Col>
                </Row>
            </Col>
        );
    }

    render() {
        const { t, order } = this.props;
        let qty = 0;
        let total = 0;

        if (order) {
            for (let i = 0; i < order.productos.length; i++) {
                const item = order.productos[i];
                if (item.cantidad) {
                    qty += item.cantidad;
                }
                if (item.precioFinal) {
                    total += parseFloat(item.precioFinal);
                }
            }
        }

        return (
            <Col>
                <Row>
                    <Col>
                        <h4>{t('Products')}</h4>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                    <Table
                        className="order-products-table"
                        columns={this.columns}
                        expandable= {{
                            expandedRowRender: (record) => this.renderRows(record)
                        }}
                        dataSource={order.productos}
                        pagination={false}
                        onChange={(pagination, filters, sorter) => {
                            this.setState({ rowSelected: 0 })
                            onChange(pagination, filters, sorter)
                        }}
                        onRow={(record, index) => {
                        }}
                        rowKey={record => record.codigodearticulo}
                        />
                        </Col>
                </Row>
                <Row>
                    <Col offset={18} style={{ paddingTop: '15px' }} >
                        <div className="totals">
                            <div>{t('Total units')} {qty}</div>
                            <div>{t('Total')} <DisplayAmount amount={total} /></div>
                        </div>
                    </Col>
                </Row>
            </Col>
        )
    }
}